import GoogleMapReact from 'google-map-react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { DEFAULT_MAP_CENTER_POSITION } from './util/constant';

const GoogleMap = ({ renderMarkers, mapCenterLocation, mapOptions }) => {
  const { i18n } = useTranslation();
  return (
    <GoogleMapReact
      bootstrapURLKeys={{
        key: process.env.REACT_APP_GOOGLE_API,
        language: i18n.language
      }}
      center={mapCenterLocation}
      {...mapOptions}>
      {renderMarkers()}
    </GoogleMapReact>
  );
};

GoogleMap.defaultProps = {
  mapOptions: {
    zoom: 6
  },
  mapCenterLocation: [
    DEFAULT_MAP_CENTER_POSITION.LAT,
    DEFAULT_MAP_CENTER_POSITION.LNG
  ],
  renderMarkers: () => null
};

GoogleMap.propTypes = {
  mapOptions: PropTypes.shape({
    zoom: PropTypes.number
  }),
  renderMarkers: PropTypes.func,
  mapCenterLocation: PropTypes.arrayOf(PropTypes.number)
};

export default GoogleMap;
